import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42fac91d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualification-dialog" }
const _hoisted_2 = { class: "qualification-dialog__header" }
const _hoisted_3 = {
  class: "qualification-dialog__icon qualification-dialog__icon--alert",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  width: "24",
  height: "24"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "qualification-dialog__heading" }
const _hoisted_7 = {
  id: "pre-allocation-confirm-title",
  class: "qualification-dialog__title"
}
const _hoisted_8 = { class: "qualification-dialog__chip" }
const _hoisted_9 = {
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "qualification-dialog__scroll" }
const _hoisted_12 = { class: "qualification-dialog__intro" }
const _hoisted_13 = { class: "qualification-dialog__body" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification-dialog__section" }, "O que falta", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification-dialog__section" }, "O que acontece ao confirmar", -1))
const _hoisted_16 = { class: "qualification-dialog__steps" }
const _hoisted_17 = { class: "qualification-dialog__step" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "“Pré-alocado · aguardando documentação”", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "qualification-dialog__step" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" Abre uma "),
    /*#__PURE__*/_createElementVNode("strong", null, "demanda urgente"),
    /*#__PURE__*/_createTextVNode(" para o Time de Documentação (Revisão de documentos › Demandas urgentes). ")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "qualification-dialog__step" }, [
  /*#__PURE__*/_createElementVNode("span", null, "O médico recebe push com o que falta e o prazo, com atalho para o Drive.")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "qualification-dialog__step" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" Documento aprovado ⇒ a alocação vira "),
    /*#__PURE__*/_createElementVNode("strong", null, "definitiva"),
    /*#__PURE__*/_createTextVNode(" e o médico é avisado. Sem resolução até 24h antes do plantão, o médico é avisado; no início do plantão o "),
    /*#__PURE__*/_createElementVNode("strong", null, "check-in fica bloqueado"),
    /*#__PURE__*/_createTextVNode(" e você decide manter ou remover. Nada é desalocado automaticamente. ")
  ])
], -1))
const _hoisted_22 = { class: "qualification-dialog__footer" }

import { computed } from 'vue'
import { mdiAccountOutline, mdiClockOutline } from '@mdi/js'

import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import type { EligibilityReason } from '@/types/qualification-eligibility.types'

import QualificationMissingList from './QualificationMissingList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreAllocationConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    doctorName: {},
    missing: {},
    stationCount: {}
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;




const isSingle = computed(() => props.stationCount === 1)

function confirm(): void {
  emit('confirm')
}

function cancel(): void {
  emit('update:modelValue', false)
  emit('cancel')
}

function onDialogUpdate(open: boolean): void {
  if (!open) cancel()
}

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "640",
    scrollable: "",
    attach: "#app",
    scrim: "rgba(22, 22, 29, 0.55)",
    "aria-labelledby": "pre-allocation-confirm-title",
    "data-testid": "pre-allocation-confirm-dialog",
    "onUpdate:modelValue": onDialogUpdate
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("path", {
                d: _unref(mdiClockOutline),
                fill: "currentColor"
              }, null, 8, _hoisted_5)
            ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, " Pré-alocar " + _toDisplayString(_ctx.doctorName ?? 'este médico') + "? ", 1),
            _createElementVNode("span", _hoisted_8, [
              (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                _createElementVNode("path", {
                  d: _unref(mdiAccountOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_10)
              ])),
              _createTextVNode(" " + _toDisplayString(_ctx.stationCount) + " " + _toDisplayString(isSingle.value ? 'plantão' : 'plantões'), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.doctorName ?? 'O médico') + " ainda não atende à Qualificação exigida desta escala, mas a escala permite pré-alocar enquanto a documentação é resolvida. ", 1),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(QualificationMissingList, { missing: _ctx.missing }, null, 8, ["missing"]),
            _hoisted_15,
            _createElementVNode("ol", _hoisted_16, [
              _createElementVNode("li", _hoisted_17, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(isSingle.value ? 'O plantão fica' : 'Os plantões ficam') + " ", 1),
                  _hoisted_18,
                  _createTextVNode(" na grade. ")
                ])
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_22, [
          _createVNode(OutlineButton, {
            height: "44px",
            width: "140px",
            color: "grey",
            "data-testid": "pre-allocation-confirm-cancel",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Cancelar ")
            ]),
            _: 1
          }),
          _createVNode(FilledButton, {
            height: "44px",
            width: "auto",
            color: "primary",
            class: "bg-primary30 px-4",
            "data-testid": "pre-allocation-confirm-submit",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Pré-alocar e abrir demanda urgente ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})